<script lang="ts">
	import { onMount } from 'svelte';
	import { navigate } from 'svelte-routing';

	export let path = '/';
	export let replace = true;

	onMount(() => navigate(path, { replace }));
</script>
